import { FiUploadIcon } from '../Icon';

import styles from './DropZone.module.scss';

import type { LoggedInUser } from '../../types/LoggedInUser';
import type { FC, ChangeEventHandler } from 'react';

export type Props = {
  loggedInUser: LoggedInUser;
  imagePreviewUrl: string;
  handleFileUpload: ChangeEventHandler<HTMLInputElement>;
};

export const DropZone: FC<Props> = ({
  loggedInUser,
  imagePreviewUrl,
  handleFileUpload,
}) => (
  <div className={styles.wrap}>
    <div className={styles['box-profile-photo']}>
      {imagePreviewUrl ? (
        <img src={imagePreviewUrl} alt="" />
      ) : (
        <img src={loggedInUser.pictureUrl} alt="" />
      )}
    </div>
    <div className={styles['box-profile-right']}>
      <label className={styles.label}>
        画像アップロード
        <FiUploadIcon />
        <input
          type="file"
          onChange={handleFileUpload}
          className={styles['input-file']}
        />
      </label>
    </div>
  </div>
);
